/**
 * 一日学习计划 - 页面用
 */
export interface PageDayPlan extends DayPlan {
  /**
   * 有无解锁
   */
  actived: boolean
}

/**
 * 一日学习计划
 */
export default interface DayPlan {
  classId?: string
  dayPlanOutlines?: Array<DayPlanOutline>
  // dayPlanOutline?: DayPlanOutline
  gmtCreated?: string
  gmtModified?: string
  id?: string
  planDay?: string
  // example: yyyy-MM-dd
  planStatus?: PlanStatus
  url?: string
  choosedOutlineIds?: string[]
  fileType?: string
}

export interface DayPlanOutline {
  courseId: string
  name: string
  planOutlines: Array<PlanOutline>
}

export interface PlanOutline {
  index: number
  outlineId: string
  name: string
}

export enum PlanStatus {
  STUDYDAY = 'STUDYDAY',
  HOLIDAY = 'HOLIDAY',
  RESTDAY = 'RESTDAY'
}

// export default interface DayPlan {
//   classId?: string
//   dayPlanOutline?: DayPlanOutline
//   gmtCreated?: string
//   gmtModified?: string
//   id?: string
//   planDay?: string
//   planStatus?: string //STUDYDAY, HOLIDAY, RESTDAY
//   url?: string
// }

// interface DayPlanOutline {
//   courseId?: string
//   outlines?: Outline[]
// }

// interface Outline {
//   id?: string
//   published?: boolean
//   sections?: Section[]
//   test?: boolean
//   title?: string
// }

// interface Section {
//   body?: SectionBody[]
//   id?: string
//   projectType?: string
//   title?: string
//   useWeb?: boolean
//   validate?: boolean
//   validateJS?: string
// }

// interface SectionBody {
//   id?: string
//   projectType?: string
//   title?: string
//   useWeb?: boolean
//   validate?: boolean
//   validateJS?: string
// }
